export default __webpack_public_path__ + "static/media/geopoll_person_icon.9c94d3c6.png";